import { useLocation, useRouteMatch } from 'react-router-dom';
import { useGetAppConfigs } from './useGetAppConfigs';
import { APP_TYPE } from '../types';
import { useUserAuth } from '../contexts/auth';
import getLeagueName from '../utils/getLeagueName';

export interface BreadCrumpItem {
  text: string;
  to: string;
}

export function useBreadcrumbs(config?: {
  beforeLinks: BreadCrumpItem[];
  afterLinks: BreadCrumpItem[];
}) {
  const { beforeLinks = [], afterLinks = [] } = config || {};
  const location = useLocation();
  const [, page, , subPage] = location.pathname.split('/');
  const { params } = useRouteMatch<{
    abbrv?: string;
    teamAbbrv?: string;
    teamId?: string;
    id?: string;
  }>();
  const selectedAbbrv = params.abbrv || params.teamAbbrv || params.teamId || params.id || null;
  const { data: appConfigs = [] } = useGetAppConfigs();
  const selectedApp = appConfigs.find((appConfig) => appConfig.abbrv === selectedAbbrv);
  const { isSuperAdmin } = useUserAuth();

  function getTo(abbrv: string) {
    const mainTo = `/${page}/${abbrv}`;
    if (
      subPage &&
      (['settings', 'scene', 'season'].includes(subPage) || !isNaN(parseInt(subPage)))
    ) {
      return `${mainTo}/${subPage}`;
    }

    return mainTo;
  }

  const links = ((): BreadCrumpItem[] => {
    if (!selectedAbbrv) {
      return [];
    }
    const selectAppLink = (() => {
      if (!selectedApp?.data.name) {
        return null;
      }

      return {
        to: getTo(selectedAbbrv),
        text: getLeagueName(selectedApp.data.name),
      };
    })();
    if (
      selectAppLink &&
      selectedApp?.data.appType === APP_TYPE.CLUB &&
      selectedApp?.data?.configLeagueName
    ) {
      return [
        {
          to: isSuperAdmin ? getTo(selectedApp.data.configLeagueName.toUpperCase()) : '',
          text: getLeagueName(selectedApp.data.configLeagueName.toLowerCase()),
        },
        selectAppLink,
      ];
    }
    if (selectAppLink && selectedApp?.data.appType === APP_TYPE.LEAGUE) {
      return [selectAppLink];
    }
    return [];
  })();

  return [...beforeLinks, ...links, ...afterLinks];
}
